<template>
  <div class="position-relative">
    <div class="btn-group d-none d-lg-block" :class="[isTutorial ? 'no-overlay no-click' : '']">
      <router-link tag="button" class="btn btn-primary" to="/me">
        <div style="display:flex; align-items:center">
          <i class="material-icons" style="margin-right:7px">person</i>
          <span>My Profile</span>
        </div>
      </router-link>
      <button
        type="button"
        class="btn btn-primary dropdown-toggle dropdown-toggle-split"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <span class="sr-only">Toggle Dropdown</span>
      </button>
      <div class="dropdown-menu dropdown-menu-right">
        <router-link class="dropdown-item" to="/scenarios/upload">Upload Scenarios</router-link>
        <router-link class="dropdown-item" to="/media/upload">Upload Media</router-link>
        <div class="dropdown-divider"></div>
        <router-link class="dropdown-item" to="/me/scenarios">My Scenarios</router-link>
        <router-link class="dropdown-item" to="/me/media">My Media</router-link>
        <div class="dropdown-divider"></div>
        <router-link class="dropdown-item" to="/logout">Sign out</router-link>
      </div>
    </div>
    <div v-if="isTutorial" class="tutorial--arrow-top profile-tutorial">
      The private profile data can be seen here.
      Also the private media and scenarios can be edited here.
    </div>

    <div class="btn-group mr-2 d-block d-lg-none">
      <div id="accordion">
        <div class="card mt-2">
          <button
            class="card-header btn btn-primary d-flex py-3 rounded"
            data-toggle="collapse"
            data-target="#loggedInUser"
            aria-expanded="true"
            aria-controls="collapseOne"
          >
            <i class="material-icons" style="margin-right:7px">person</i>
            <span>My Profile</span>
          </button>

          <div
            id="loggedInUser"
            class="collapse"
            aria-labelledby="userProfile"
            data-parent="#loggedInUser"
          >
            <div class="card-body">
              <div class>
                <router-link class="dropdown-item" to="/scenarios/upload">Upload Scenarios</router-link>
                <router-link class="dropdown-item" to="/media/upload">Upload Media</router-link>
                <div class="dropdown-divider"></div>
                <router-link class="dropdown-item" to="/me/scenarios">My Scenarios</router-link>
                <router-link class="dropdown-item" to="/me/media">My Media</router-link>
                <!-- <router-link class="dropdown-item" to="/me/remote-support">Remote support</router-link> -->
                <div class="dropdown-divider"></div>
                <router-link class="dropdown-item" to="/logout">Sign out</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- mobile -->
  </div>
</template>

<script>
import DeviceInformation from "../components/DeviceInformation";
export default {
  name: "LoggedInUser",
  components: {
    DeviceInformation
  },
  computed: {
    isTutorial() {
      return this.$store.getters.getShowTutorial;
    }
  }
};
</script>

<style scoped>
@media (max-width: 991px) {
  .btn-group {
    width: 100%;
  }
}

.dropdown-submenu {
  position: relative;
}

.dropdown-submenu .dropdown-menu {
  top: 0;
  left: 100%;
  margin-top: -1px;
}

.profile-tutorial {
  top: 45px;
  left: 0;
  right: 0;
}
</style>

